import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import BreachCategoryForm from '../Forms/BreachCategoryForm';

const AddEditBreachCategoryModal = ({
	dataBreachCategory,
	isOpen,
	isEdit,
	handleToggleModal,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Categoría de Incumplimiento
			</ModalHeader>

			<BreachCategoryForm
				dataBreachCategory={dataBreachCategory}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditBreachCategoryModal;
